export const numberValidation = (str) => str.match(/^[0-9]+([.,][0-9]+)?$/)? '' : 'Неверный формат'